// extracted by mini-css-extract-plugin
export default {"menuCheckbox":"menuCheckbox___Ezvtd","menuCheckbox_label":"menuCheckbox_label___VzFyE"};